import { SwitchStepSchema } from '@feedyou/schema'
import { checkpointIdGenerators, isNotEmptyElement } from '@feedyou/utils'

import { GetSubdialogConnectionsMetadata } from '../../../types'

export const getSubdialogConnectionsMetadata: GetSubdialogConnectionsMetadata<SwitchStepSchema> = (
  step,
  parentDialogId
) => {
  const { cases = [] } = step

  const defaultDialogMetadata = step.default?.dialog
    ? {
        checkpointLink: checkpointIdGenerators.switchCase(step.id),
        parentDialog: parentDialogId,
        childDialog: step.default.dialog
      }
    : undefined

  const caseDialogMetadata = cases?.map(switchCase => {
    if (!switchCase.dialog) {
      return null
    }

    return {
      checkpointLink: checkpointIdGenerators.switchCase(step.id, switchCase.id),
      parentDialog: parentDialogId,
      childDialog: switchCase.dialog
    }
  })

  return [...caseDialogMetadata, defaultDialogMetadata].filter(isNotEmptyElement)
}
